import React from 'react'
import { Box, Flex, Grid, GridItem,Text } from '@chakra-ui/react'
import MyDiv from './department.style'
import { DepartementList } from "./components"

const Department = () => {  
 

  return (
    <MyDiv>
      <Box className="page_wrapper">
        <Flex className="page_heading flex_header" >
          <Text className="font-poppins text_semibold text_3xl">Department</Text>
          <Flex gap={2}>
          </Flex>
        </Flex>
      </Box>
      <Grid className="grid_container grid_gap_sm">
        <GridItem colSpan={12}  >
          <DepartementList  />
        </GridItem>
      </Grid>
    </MyDiv>
  )
}

export default Department
